import lang from '@/lang'
import { splitFilename } from '@/modules/_helpers/splitFilename'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { FORBIDDEN_FILENAME_CHARACTERS } from '@/modules/base/util/constants'
import { ALLOWED_FILE_EXTENSIONS } from '@/modules/file/uploader'

const formatExtensionsForMessage = (extensions) => extensions.map(ext => `'${ext}'`).join(', ')

export const validateFileName = (file, message = null, forbidden, allowedExtensions = ALLOWED_FILE_EXTENSIONS, checkExtensions = true) => {
  const fileName = file.name
  if ((forbidden ?? FORBIDDEN_FILENAME_CHARACTERS).some(char => fileName.includes(char))) {
    toast.showToast({ type: 'error', message: message || lang.fileUploaderSpecialCharactersError(FORBIDDEN_FILENAME_CHARACTERS.join(' ')) })
    return false
  }
  if (checkExtensions && fileName.includes('.') && !allowedExtensions.includes(splitFilename(fileName, true).suffix.toLowerCase())) {
    toast.showToast({ type: 'error', message: lang.fileUploaderTypesError.replace('%s', formatExtensionsForMessage(allowedExtensions)).replace('{file}', fileName) })
    return false
  }
  return file
}

export default validateFileName
